import { z } from 'zod'
import { BasicRequest } from '@/api/api'
import { PlatformShortcode } from '@/utils/convert-platform'

export type ValuationPlatformType =
  | PlatformShortcode.Facebook
  | PlatformShortcode.Instagram
  | PlatformShortcode.TikTok
  | PlatformShortcode.YouTube
  | PlatformShortcode.Twitter

const platformValuationSchema = z.object({
  view_value: z.number(),
  comment_value: z.number(),
  like_value: z.number(),
  share_value: z.number(),
})

export interface ValuationRequest extends BasicRequest {
  default?: boolean
}
export const valuationResponseSchema = z.object({
  workspace_id: z.number(),
  fb: platformValuationSchema,
  yt: platformValuationSchema,
  ig: platformValuationSchema,
  tiktok: platformValuationSchema,
  twitter: platformValuationSchema,
})

export type PlatformValuationSchema = z.infer<typeof platformValuationSchema>
export type ValuationResponse = z.infer<typeof valuationResponseSchema>
export type UpdateValuationResponse = ValuationResponse
export type UpdateValuationRequest = ValuationResponse
